import { FONT_SIZE_CHANGED, DISABILITY, DYSLEXIA } from "../../constants";

const initState = {
  isImpaired: false,
  isDyslexic: false,
  fontSize: 100,
};

// Dodjela funkcije varijabli
const reducer = (state = initState, action) => {
  switch (action.type) {
    case DISABILITY:
      return {
        ...state,
        isImpaired: action.payload,
      };
    case DYSLEXIA:
      return {
        ...state,
        isDyslexic: action.payload,
      };
    case FONT_SIZE_CHANGED:
      return {
        ...state,
        fontSize: action.payload,
      };
    default:
      return state;
  }
};

// Izvoz funkcije
export default reducer;